import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dd6b8070"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "server-details" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "New Data Source", -1))
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "serverName" }, "Server Name", -1))
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "host" }, "Host", -1))
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "userId" }, "User ID", -1))
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "password" }, "Password", -1))
const _hoisted_11 = { class: "navigation" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("p", null, "Selected Server Type: " + _toDisplayString($setup.serverType), 1),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ($setup.serverName = $event)),
        id: "serverName",
        type: "text",
        placeholder: "Enter server name"
      }, null, 512), [
        [_vModelText, $setup.serverName]
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ($setup.host = $event)),
        id: "host",
        type: "text",
        placeholder: "Enter host"
      }, null, 512), [
        [_vModelText, $setup.host]
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ($setup.userId = $event)),
        id: "userId",
        type: "text",
        placeholder: "Enter user ID"
      }, null, 512), [
        [_vModelText, $setup.userId]
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _hoisted_10,
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ($setup.password = $event)),
        id: "password",
        type: "password",
        placeholder: "Enter password"
      }, null, 512), [
        [_vModelText, $setup.password]
      ])
    ]),
    _createElementVNode("button", {
      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => ($options.testConnection && $options.testConnection(...args)))
    }, "Test Connection"),
    _createElementVNode("button", {
      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => ($options.saveDetails && $options.saveDetails(...args)))
    }, "Save"),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("button", {
        onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => ($setup.goBack && $setup.goBack(...args)))
      }, "Back"),
      _createElementVNode("button", {
        onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => ($setup.goNext && $setup.goNext(...args)))
      }, "Next")
    ])
  ]))
}